customElements.get("video-reels") || customElements.define("video-reels", class extends HTMLElement {
   constructor() {
      super(), this.activeClass = "active", this.swiper = this.querySelector(".wt-slider__container")
   }
   connectedCallback() {
      this.init()
   }
   updateAllVideosSound(swiper) {
      const soundOn = swiper.el.dataset.sound === "on";
      swiper.slides.forEach(slide => {
         let video = slide.querySelector("video");
         video && (video.muted = !soundOn)
      })
   }
   observeSection() {
      const observerOptions = {
         root: null,
         rootMargin: "0px",
         threshold: .1
      };
      new IntersectionObserver((entries, observer) => {
         entries.forEach(entry => {
            const video = document.querySelector(".swiper-slide-active video");
            video && (entry.isIntersecting ? video.play() : video.pause())
         })
      }, observerOptions).observe(this)
   }
   handleSoundToggle(swiper) {
      swiper.slides.forEach((slide, index) => {
         const button = slide.querySelector(".wt-video__sound-toggle"),
            video = slide.querySelector("video"),
            that = this;
         button.addEventListener("click", function () {
            video && (video.muted ? (video.muted = !1, swiper.el.dataset.sound = "on") : (video.muted = !0, swiper.el.dataset.sound = "off"), that.updateAllVideosSound(swiper))
         })
      })
   }
   pasueAllVideos() {
      this.querySelectorAll("video").forEach(video => {
         video.pause()
      })
   }
   playVideoInActiveSlide(swiper) {
      const sound = swiper.el.dataset.sound,
         activeSlideVideo = this.findActiveSlide(swiper)?.querySelector("video");
      activeSlideVideo && (activeSlideVideo.play(), activeSlideVideo.muted = sound !== "on")
   }
   findActiveSlide(swiper) {
      return swiper.slides[swiper.activeIndex]
   }
   toggleActiveClass(swiper) {
      const activeSlide = this.findActiveSlide(swiper);
      swiper.slides.forEach(slide => {
         slide.classList.remove(this.activeClass), activeSlide === slide && slide.classList.add(this.activeClass)
      })
   }
   handleSlideChange(swiper) {
      this.pasueAllVideos(), this.toggleActiveClass(swiper), this.playVideoInActiveSlide(swiper)
   }
   addVideoEventHandlers(swiper) {
      const that = this;
      swiper.on("slideChange", swp => that.handleSlideChange(swp))
   }
   checkSwiperInitialization() {
      const swiperContainer = this.swiper,
         mySwiperInstance = swiperContainer.swiper;
      swiperContainer.classList.contains("swiper-initialized") && (this.addVideoEventHandlers(mySwiperInstance), this.handleSlideChange(mySwiperInstance), this.handleSoundToggle(mySwiperInstance), this.observeSection(), clearInterval(this.checkInterval))
   }
   init() {
      this.checkInterval = setInterval(this.checkSwiperInitialization.bind(this), 500)
   }
});
//# sourceMappingURL=/cdn/shop/t/18/assets/video-reels.js.map?v=162189021284462521221752578292